export default {"src":"/_next/static/media/app-illu.3b6c05e3.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};